export function kFormatter(num: number): string {
  const result =
    num > 999
      ? `${Math.sign(num) * +(Math.abs(num) / 1000).toFixed(1)}k`
      : (Math.sign(num) * Math.abs(num)).toString()

  return result
}
